import React from "react";
import { ReactComponent as CurveSecondary } from "../../assets/curve-secondary.svg";
import { ReactComponent as CurveMobile } from "../../assets/curve-mobile.svg";
import { ReactComponent as Curve } from "../../assets/curve.svg";
import VisibilitySensor from "react-visibility-sensor";
import FadeInUp from "../shared/animations/fadeInUp";

export default function About() {
  return (
    <section className="third-section">
      <div className="about-bg-image about-bg-image--accupuncture desktop d-none d-lg-flex" />
      <Curve
        preserveAspectRatio="xMaxYMax meet"
        className="d-none d-lg-block about-mid-curve fill-white"
      />
      <CurveSecondary className="fill-secondary-light about-top-curve" />
      <div className="container">
        <div className="row m-0 mt-5 mb-5 pb-0 pb-lg-5">
          <div className="col-lg-5">
            <VisibilitySensor partialVisibility={true}>
              {({ isVisible }) => (
                <FadeInUp once delay="0" fadeIn={isVisible ? true : false}>
                  <h2 className="mb-4">Wie is Guillem?</h2>
                  <p>Guillem is zeer zorgzaam en empathisch. Hij luistert graag naar zijn patiënten en helpt hen met passie om te herstellen van gezondheidsproblemen. Zijn keuze voor kinesitherapie en acupunctuur is gedreven door zijn verlangen om mensen te ondersteunen en te genezen. Hij gelooft dat zijn handen gemaakt zijn om te helen, en dit werk geeft hem energie en geluk.</p>
                  <p>
                    Guillem begrijpt dat pijn en ziekte bij het leven horen, maar dat niemand er alleen onder hoeft te lijden. Hij nodigt je uit om samen met hem de balans te vinden en je gezondheid te herstellen.
                  </p>
                  <h2>
                    Hoe gaat Guillem te werk?
                  </h2>
                  <p>
                    Guillem werkt met verschillende technieken, waaronder acupunctuur (met zeer fijne naalden), moxa (het verwarmen van acupunten), cupping en acupressuur. Elke behandeling wordt op maat gemaakt en aangepast aan de individuele behoeften van de patiënt. Voor mensen die niet geschikt zijn voor naalden, zoals kleine kinderen, baby’s, of patiënten met fobieën of specifieke ziekten, past hij alternatieve methoden toe.
                  </p>
                  <p className="pb-4">
                    Guillem hecht veel waarde aan veiligheid en luisteren. Hij neemt de tijd om écht naar zijn patiënten te luisteren in een relaxte sfeer, zodat hij holistisch te werk kan gaan. Het is belangrijk voor hem dat patiënten zich gehoord en veilig voelen tijdens hun behandeling.
                  </p>
                </FadeInUp>
              )}
            </VisibilitySensor>
          </div>
        </div>
      </div>
      <div className="about-bg-image about-bg-image--accupuncture mobile d-lg-none">
        <CurveMobile className="fill-white about-mobile-curve" />
      </div>
    </section>
  );
}
